import React from "react";
import { Button } from "@mui/material";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const ButtonText = (props) => {
    return (
        <>
            <Button sx={{
                "&.MuiButtonBase-root": {
                    backgroundColor: "#c69749",
                    borderRadius: 25,
                    width: "fit-content",
                    px: 1.5,
                    py: 0.8,
                    textTransform: "capitalize",
                    color: "#fff",
                },
            }}
                onClick={() => props.onClickBtn()}
                startIcon={
                    <AddCircleOutlineOutlinedIcon
                        style={{ fontSize: 18, color: "#fff" }}
                    />
                }
            >
                {props.text}
            </Button>
        </>
    )
}

export default ButtonText